<template>
  <div class="app-container">
    <div class="filter-container flex">
      <div>
        <el-button type="primary" icon="el-icon-plus" size="small" @click="handleAddTable">新增</el-button>
        <el-button type="warning" icon="el-icon-upload2" :loading="listLoading" size="small"
          @click="exportExcel">导出Excel</el-button>
      </div>
      <div>
        <el-input v-model="listQuery.title" placeholder="名称" style="width: 180px;" class="filter-item" size="small"
          clearable />
        <el-select v-model="listQuery.type" placeholder="类型" class="filter-item" style="width: 200px" type="primary"
          size="small" clearable>
          <el-option label="积分" :value="1" />
          <el-option label="实物" :value="2" />
          <el-option label="谢谢惠顾" :value="3" />
        </el-select>
        <el-select v-model="listQuery.state" placeholder="状态" class="filter-item" style="width: 200px" type="primary"
          size="small" clearable>
          <el-option label="正常" :value="1" />
          <el-option label="已下架" :value="0" />
        </el-select>
        <el-button type="primary" class="filter-item" icon="el-icon-search" :loading="listLoading" size="small"
          @click="handleFilter">搜索</el-button>
      </div>
    </div>


    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" border fit highlight-current-row >
      <el-table-column type="index" align="center" label="序号" width="95" />
      <el-table-column align="center" label="图片" width="150">
        <template slot-scope="scope">
          <el-image v-if="scope.row.type === 2" class="image-url" :src="scope.row.img"
            :preview-src-list="[scope.row.img]" />
          <img style="display: inline-block;" v-else-if="scope.row.type === 3" src="@/icons/point.png" alt="point">
          <img style="display: inline-block;" v-else-if="scope.row.type === 1" src="@/icons/thanks.png" alt="thanks">
        </template>
      </el-table-column>
      <el-table-column label="名称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.title }}
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="奖品类型" min-width="120" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.type === 1">积分</el-tag>
          <el-tag v-else-if="scope.row.type === 2">实物</el-tag>
          <el-tag v-else-if="scope.row.type === 3">谢谢惠顾</el-tag>
          <el-tag v-else>后端无字段</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="中奖概率" min-width="110" align="center">
        <template #default="{ row: { probability } }">
          <el-tag type="danger" size="medium">{{ probability }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="价值" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.type === 1">{{ scope.row.worth }}</el-tag>
          <el-tag v-else-if="scope.row.type === 2">{{ scope.row.worth }}</el-tag>
          <el-tag v-else>0</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="奖品数量" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.type === 3">不限</el-tag>
          <el-tag v-else>{{ scope.row.prize_num }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="剩余奖品数量" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.type !== 3">{{ scope.row.prize_num - scope.row.winners_num }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="累计中奖人数" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag>{{ scope.row.winners_num }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="排序" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.sort }}
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="状态" min-width="60" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.state === 1" type="primary">正常</el-tag>
          <el-tag v-else-if="scope.row.state === 0" type="warning">已下架</el-tag>
          <el-tag v-else>后端无字段</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" width="230" class-name="small-padding fixed-width" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleUpdate(scope.row)">编辑</el-button>
          <el-button v-if="scope.row.state === 1" type="warning" size="mini"
            @click="handleForbid(scope.row.id, '下架')">下架</el-button>
          <el-button v-else size="mini" type="primary" @click="handleForbid(scope.row.id, '上架')">上架</el-button>

          <el-button size="mini" type="danger" @click="handleDel(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>


    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
        :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </div>

    <TableActionModal :show.sync="activeVisible" :type="activeModalType" :edit-data="activeEditData"
      @onUpdate="onTableActionModalSubmit" />
  </div>
</template>

<script>
// 抽奖商品信息
// import { getQiniuToken } from "@/api/common";
import request from "@/utils/request";
// import { guid, base64toFile } from "@/utils/index";
import "babel-polyfill"; // es6 shim
import uploadList from "@/components/UploadList/index.vue";
import Tinymce from '@/components/Tinymce'
import TableActionModal from "./components/TableActiveModal.vue"
import { prize } from '@/api/draw';
import * as XLSX from "xlsx"

export default {
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10
      },
      form: {
        id: "",
        type: 1,
        sort: "",
        title: "",
        prize_num: '',
        winners_num: '',
        worth: '',
        probability: '',
        img: '',
      },
      activeVisible: false,
      activeModalType: 'add',
      activeEditData: {
        id: '',
        type: '',
        title: '',
        worth: '',
        img: '',
        probability: '',
        prize_num: '',
        sort: ''
      },
      btnLoading: false,
    };
  },
  components: {
    Tinymce,
    uploadList,
    TableActionModal
  },
  methods: {
    getList() {
      this.listLoading = true;
      request({
        url: "/api/backend/draw/list", // category_id:{1.首页轮播图}
        method: "get",
        params: this.listQuery
      }).then(({ data }) => {
        let formatData = data.data.sort((v1, v2) => v2.sort - v1.sort)

        this.list = formatData;
        this.total = data.total;
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    setActiveModalType(type) {
      this.activeModalType = type
    },
    handleAddTable() {
      this.setActiveModalType('add')
      this.activeVisible = true
    },
    handleUpdate(data) {
      this.setActiveModalType('edit')
      this.activeEditData = data
      console.log('数据', this.activeEditData)
      this.activeVisible = true
    },
    onTableActionModalSubmit() {
      this.getList()
    },
    handleForbid(val, text) {
      this.$confirm("此操作将" + text + "该奖品, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          request({
            url: "/api/backend/draw/state",
            method: "post",
            data: { id: val }
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功!"
            });
          });
        })
        .catch(() => { });
    },
    handleDel(id) {
      this.$confirm("确定要删除, 是否继续?", "提示", {
        type: "warning"
      }).then(async () => {
        try {
          await prize.delete(id)
          this.$message({
            type: 'success',
            message: "删除成功"
          })
          this.getList()
        } catch (err) {
          console.log('删除失败', err)
        }
      })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    checkState(state) {
      // console.log('状态',state)
      switch (Number(state)) {
        case 0: return { txt: '待填写地址', type: 'info' };
        case 1: return { txt: '已完成', type: 'success' };
        case 2: return { txt: '待发货', type: 'warning' };
        case 3: return { txt: '已发货', type: 'primary' };
      }
    },
    checkType(state) {
      switch (Number(state)) {
        case 1: return '积分';
        case 2: return '实物';
        case 3: return '谢谢惠顾';
      }
    },
    // 导出Excel
    async exportExcel() {
      console.log('exportExcel')

      const { total } = this
      if (!total) return

      try {
        const { data: { data: reqData } } = await request({
          url: "/api/backend/draw/list",
          method: "get",
          params: { ...this.listQuery, page: 1, limit: total }
        })

        var wb = XLSX.utils.book_new();

        var excelData = [
          ['序号', '名称', '奖品类型', '中奖概率', '价值', '奖品数量', '剩余奖品数量', '累计中奖人数', '状态'],
          ...reqData.map((item, index) => [
            index + 1,
            item.title,
            item.type === 1 ? '积分' : item.type === 2 ? '实物' : item.type === 3 ? '谢谢惠顾' : '后端无字段',
            item.probability,
            item.worth ? item.worth : 0,
            item.type === 3 ? '不限' : item.prize_num,
            item.type !== 3 ? item.prize_num - item.winners_num : '',
            item.winners_num,
            item.state ? '正常' : '已下架'
          ])
        ];
        var ws = XLSX.utils.aoa_to_sheet(excelData);
        XLSX.utils.book_append_sheet(wb, ws, "抽奖商品");
        XLSX.writeFile(wb, "抽奖管理-抽奖商品.xlsx");

        this.$notify.info({
          title: '消息',
          message: '请等待, 正在生成Excel表格文件...'
        });
      } catch {
        this.$notify.error({
          title: '错误',
          message: '获取数据错误!'
        });
      }
    }
  },
  created() {
    this.getList();
  },
};
</script>

<style scoped>
.upload-block {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 120px;
  height: 120px;
}

.uploaded-img {
  width: 120px;
  height: 120px;
}

.upload-block:hover {
  border-color: #409eff;
}

.uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.upload-one-component .upload-one-component-image {
  width: auto;
  height: 200px;
}

.flex {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
</style>
